export const GREYSCALE = {
  BLACK: '#171615',
  DARKEST: '#474443',
  DARKER: '#726c68',
  DARK: '#a09d9a',
  DEFAULT: '#d9d4d1',
  LIGHT: '#ebe7e4',
  LIGHTER: '#f7f4f2',
  LIGHTEST: '#f7f4f2',
  WHITE: '#ffffff',
  BLACK_TRANSPARENT: '#000000b3',
  TRANSPARENT: 'transparent',
} as const;
